"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var SetResource = /** @class */ (function (_super) {
    tslib_1.__extends(SetResource, _super);
    function SetResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SetResource.endpoint = '/sets';
    SetResource.MODEL_NAME = 'set';
    return SetResource;
}(base_1.default));
exports.default = SetResource;
//# sourceMappingURL=set.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/system/set.js
// module id = w6pe
// module chunks = 0